export const LOAD_WORKFLOWS = 'LOAD_WORKFLOWS';
export const ADD_WORKFLOW = 'ADD_WORKFLOW';
export const UPDATE_WORKFLOWS = 'UPDATE_WORKFLOWS';
